import { useState, useEffect } from "react";
import { Modal } from 'bootstrap';

export default function EventDialog(props) {
  const [ show, setShow ] = useState(props.show);
  const [ message, setMessage ] = useState(props.message);



  const showDialog = () => {
    let modal = new Modal(document.getElementById('EventDialog'));
    modal.show();
  }

  const hideDialog = () => {
    document.getElementById('_dialogCloser2').click();
  }

  useEffect(() => {
    document.getElementById('EventDialog').addEventListener('hide.bs.modal', (e) => {
      setShow(false);
    });
  }, [ ]);

  useEffect(() => {
    setShow(props.show);
    setMessage(props.message);
  }, [ props.show, props.message ]);



  useEffect(() => {
    if(show) {
      showDialog();
    } else {
      hideDialog();
    }
  }, [ show ]);

  return (
    <div style={{ zIndex: "var(--allHighIndex)" }} className="modal fade" id="EventDialog" tabIndex="-1" aria-labelledby="EventDialog" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered modal-md">
        <div className="modal-content">
          <div className="modal-body" style={{ padding: "0px", margin: "0px", width: "100%" }}>
            {message}
          </div>
          <div className="modal-footer" style={{ padding: "0px", border: "none", marginTop: "0px", }}>
            <button  id="_dialogCloser2" type="button" className="btn bg-goldish no-shadow btn-block" data-bs-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>

  )
}
